import { createContext, useContext } from "react";

import { type SectionId } from "@/analytics/events";

/** Set by the blueprint `Section`, read by [useTrack]. */
const SectionContext = createContext<SectionId | undefined>(undefined);

export const SectionProvider = SectionContext.Provider;

export const useSectionId = (): SectionId | undefined =>
  useContext(SectionContext);
